import { css, keyframes } from 'styled-components';

const DEFAULT_ANIMATION_DURATION = 200;
const ROTATION_ANIMATION_DURATION = 1200;

export const ANIMATIONS = {
  FADE_IN: 'fadeIn',
  FADE_OUT: 'fadeOut',
  ROTATE: 'rotate'
} as const;

type Animations = typeof ANIMATIONS;
export type Animation = Animations[keyof Animations];

export interface IAnimationProps {
  useFadeIn?: boolean;
  useFadeOut?: boolean;
  visible?: boolean;
  useRotate?: boolean;
}

type IAnimations = Record<Animation, ReturnType<typeof keyframes>>;

const animationKeyframes: IAnimations = {
  [ANIMATIONS.FADE_IN]: keyframes`
    from {  opacity: 0; }
    to { opacity: 1; }
  `,
  [ANIMATIONS.FADE_OUT]: keyframes`
    from {  opacity: 1; }
    to { opacity: 0.5; }
  `,
  [ANIMATIONS.ROTATE]: keyframes`
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  `
};

export const useFadeInCss = css<Pick<IAnimationProps, 'useFadeIn' | 'visible'>>`
  ${({ useFadeIn, visible }) =>
    useFadeIn === true &&
    visible === true &&
    css`
      visibility: visible;
      animation: ${animationKeyframes[ANIMATIONS.FADE_IN]} ${DEFAULT_ANIMATION_DURATION}ms linear;
      transition: visibility ${DEFAULT_ANIMATION_DURATION}ms linear;
    `};
`;

export const useFadeOutCss = css<Pick<IAnimationProps, 'useFadeOut' | 'visible'>>`
  ${({ useFadeOut, visible }) =>
    useFadeOut === true &&
    visible === false &&
    css`
      visibility: hidden;
      animation: ${animationKeyframes[ANIMATIONS.FADE_OUT]} ${DEFAULT_ANIMATION_DURATION}ms linear;
      transition: visibility ${DEFAULT_ANIMATION_DURATION}ms linear;
    `};
`;

export const useRotateAnimationCss = css<Pick<IAnimationProps, 'useRotate'>>`
  ${({ useRotate }) =>
    useRotate === true &&
    css`
      animation: ${animationKeyframes[ANIMATIONS.ROTATE]} ${ROTATION_ANIMATION_DURATION}ms linear infinite;
    `};
`;
